import React, { FC, ReactChild } from 'react';
import styled from '@emotion/styled';
import { BodyProps, Box, BoxProps, Select } from '@hover/blueprint';
import StyledFloatingLabelWrapper from './StyledFloatingLabelWrapper';

interface Props extends BoxProps {
  options: string[];
  label: string | ReactChild;
  valueProps?: BodyProps;
  defaultValue?: string;
  setValue: Function;
  selectedValue: string;
}

const StyledSelectWrapper = styled(Box)`
  width: 100%;
  position: relative;

  .chakra-select__icon-wrapper {
    display: none !important;
  }

  select {
    height: calc(3.5rem + 2px);
    padding-top: 26px !important;
    color: #0e3054;
  }

  label {
    opacity: 0.65;
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    padding: 1rem 0.75rem;
    pointer-events: none;
    border: 1px solid transparent;
    transform-origin: 0 0;
    transition: opacity 0.1s ease-in-out 0s, transform 0.1s ease-in-out 0s;
  }
`;

const FloatingLabelSelector: FC<Props> = ({
  options,
  label,
  valueProps,
  defaultValue,
  setValue,
  selectedValue,
  ...rest
}) => (
  <StyledFloatingLabelWrapper>
    <Box className="form-floating" {...rest}>
      <StyledSelectWrapper>
        <Select
          value={selectedValue}
          className="form-select"
          color="primary.900"
          id="floatingSelect"
          aria-label="Floating label select example"
          defaultValue={defaultValue}
          onChange={({ target: { value } }) => {
            setValue(value);
          }}
        >
          {options.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Select>
        <label htmlFor="floatingSelect">{label}</label>
      </StyledSelectWrapper>
    </Box>
  </StyledFloatingLabelWrapper>
);
FloatingLabelSelector.defaultProps = {
  valueProps: {},
  defaultValue: undefined,
};

export default FloatingLabelSelector;
